import { useQuery } from "@tanstack/react-query";
import { getDashboardById } from '@src/utils/dashboard/db';
import { isDashboardGeneratedAtom, panelWidthAtom } from "@src/components/nexa/NexaStore";
import { useSetAtom } from "jotai";
import { logger } from "@src/utils/misc/logger";


const useCheckDashboardEntry = ({ id }) => {
  const setPanelWidth = useSetAtom(panelWidthAtom);
  const setIsDashboardGenerated = useSetAtom(isDashboardGeneratedAtom);

  const { isFetching, isError } = useQuery(
    ['nexa-gen-dash', id],
    async () => {
      const dashboard = await getDashboardById(id);
      const hasDashboard = !!dashboard && !!dashboard.id;

      logger.log('Checked dashboard entry', { id, hasDashboard });

      setIsDashboardGenerated(hasDashboard);
      setPanelWidth(hasDashboard ? 30 : 100);

      return dashboard || null;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000,
      notifyOnChangeProps: ['isFetching', 'isError']
    }
  );

}

export default useCheckDashboardEntry;
